import React from "react";
import "./Category.scss";
import { Col, Row, Image } from "antd";
import Helpers from "@utils/Helpers";
import { useNavigate } from "react-router-dom";

const Category: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="Category-section">
      <div className="container">
        <div className="section-title-group">
          <div className="section-title">Categories</div>
        </div>
        <Row gutter={12}>
          <Col span={8}>
            <div className="category-item" onClick={() => navigate("/products")}>
              <Image
                width={"100%"}
                className="category-image"
                src={Helpers.getImageFrontPage("hay")}
                preview={false}
              />
              <div className="category-title">Hay</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="category-item" onClick={() => navigate("/products")}>
              <Image
                width={"100%"}
                className="category-image"
                src={Helpers.getImageFrontPage("straw")}
                preview={false}
              />
              <div className="category-title">Straw</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="category-item coming-soon">
              <Image
                width={"100%"}
                className="category-image"
                src={Helpers.getImageFrontPage("hayseed")}
                preview={false}
              />
              <div className="category-title">Hay Seed</div>
              <div className="watermark">
                <div className="background"></div>
                <p className="coming-soon">COMING SOON</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Category;
